const fuelGrades = {
    'hfo' :'HFO',
    'lfo' :'LFO',
    'mgo' :'MGO',
    'mdo' :'MDO',
    'ulsfo2020' :'ULSFO2020',
    'ulslfo2020' :'ULSLFO2020',
    'ulsmdo2020' :'ULSMDO2020',
    'ulsmgo2020' :'ULSMGO2020',
    'vlsfo2020' :'VLSFO2020',
    'vlslfo2020' :'VLSLFO2020',
    'ethane': 'Ethane',
    'lpgp' :'LPGP',
    'lpgb' :'LPGB',
    'lng' :'LNG',
    'methanol' :'Methanol',
    'ethanol' :'Ethanol',
    'hvo': 'HVO',
    'fame': 'FAME',
    'biodiesel': 'Biodiesel',
    'bio_lng' : 'Bio-LNG',
    'other' :'Other'
}

const lngFuelGrades = [
    'lng',
   'bio_lng'
]
const bannedFuelGrades = [
    'B10LFO',
    'B10MGO',
    'BIOLFO',
    'BIOMGO'
]

const gaseousFuelGrades = [
    'lpgb',
    'lpgp',
    'lng',
    'bio_lng',
    'ethane'
]

const isoGradeFuelMapping = {
    'hfo' :['RME180','RMG180','RMG380','RMG500','RMG700','RMK380','RMK500','RMK700'],
    'lfo' :['RMA10','RMB30','RMD80'],
    'mgo' :['DMA','DMX','DFA','DMZ','DFZ','DMB','DFB'],
    'mdo' :['DMA','DMX','DFA','DMZ','DFZ','DMB','DFB'],
    'b10lfo' :['RMA10','RMB30','RMD80'],
    'b10mgo' :['DMA','DMX','DFA','DMZ','DFZ','DMB','DFB'],
    'biolfo' :['RMA10','RMB30','RMD80'],
    'biomgo' :['DMA','DMX','DFA','DMZ','DFZ','DMB','DFB'],
    'ulsfo2020' :['RMA10','RMB30','RMD80','RME180','RMG180','RMG380','RMG500','RMG700','RMK380','RMK500','RMK700','DMA','DMX','DFA','DMZ','DFZ','DMB'],
    'ulslfo2020' :['RMA10','RMB30','RMD80'],
    'ulsmdo2020' :['DMA','DMX','DFA','DMZ','DFZ','DMB','DFB'],
    'ulsmgo2020' :['DMA','DMX','DFA','DMZ','DFZ','DMB','DFB'],
    'vlsfo2020' :['RMA10','RMB30','RMD80','RME180','RMG180','RMG380','RMG500','RMG700','RMK380','RMK500','RMK700','DMA','DMX','DFA','DMZ','DFZ','DMB'],
    'vlslfo2020' :['RMA10','RMB30','RMD80'],
    'ethane' :['Ethane'],
    'lpgp' :['LPG'],
    'lpgb' :['LPG'],
    'lng' :['LNG'],
    'methanol' :['Methanol'],
    'ethanol' :['Ethanol'],
    'hvo' :['HVO'],
    'fame' :['FAME'],
    'biodiesel' : ['Biodiesel'],
    'bio_lng' : ['Bio-LNG'],
    'other' :['Other']
}

var addUsedFuelstoListOfFuels = function(enabledFuels, fuelsUsedInReport) {
    var enabled_fuel_types = enabledFuels
    if (fuelsUsedInReport != undefined && fuelsUsedInReport.length > 0) {
        for (var j=0; j<fuelsUsedInReport.length; j++) {
            if (enabled_fuel_types.includes(fuelsUsedInReport[j]) != true) {
                enabled_fuel_types.push(fuelsUsedInReport[j])
            }
        }
    }
    return enabled_fuel_types
}

export {
    fuelGrades,
    lngFuelGrades,
    bannedFuelGrades,
    gaseousFuelGrades,
    isoGradeFuelMapping,
    addUsedFuelstoListOfFuels,
}